//chapter1
export default {
    id : 11,//chapter number
    title : '11. DFMEA 작성방법 (4) - DFMEA 고장분석',//chapter name
    slides : [
        {
            title : 'Intro',
            type : 'intro',
            source : 'c11.mp4',
        },
        {
            title : 'Today’s Goal',
            type : 'plan',
            body1 : [
                'DFMEA 고장분석',
            ],
            body2 : [
                'DFMEA 고장분석에 대해 설명할 수 있다.'
            ],
            bgm : "plan.mp3"
        },
        {
            title : 'Lesson',
            type : 'lesson',
            source : '11.mp4',
        },
        {
            title : 'Quiz',
            type : 'quiz',
            quiz : [
                {
                    type : 'ox',
                    question : '고장은 기능으로부터 도출된다.',//html available
                    answer : "1",
                    explain : '기능에 의해 고장이 정의되어야 한다.'
                },
                {
                    type : 'ox',
                    question : '고장 Chain은 고장영향, 고장형태, 고장원인으로 구성된다.',//html available
                    answer : "1",
                    explain : '고장 Chain의 연결 구조이다.'
                },
            ],
            quizMask : "../assets/images/quiz_intro.jpg",//quiz mask
            bgm : "quiz.mp3"
        },
        {
            title : 'Summary',
            type : 'summary',
            /*download : 'sample.pptx',//data folder*/
            print : false,// true : show, false: hide
            slides : [
                {
                    body : `<ul>
                        <h3>1. 고장유형</h3>
                        <li>기능 상실, 부분적 기능</li>
                        <li>기능 저하, 기능 지연</li>
                        <li>공정단계의 고장 : 부적합, 부분동작, 스크랩, rework, repair etc. </li>
                    </ul>`
                },
                {
                    body : `<ul>
                        <h3>2. 고장 Chine 이해와 작성방법</h3>
                        <li>고장영향 : 고장형태의 연결하여 정의됨</li>
                        <li>고장형태 : 기능으로부터 도출되며 고객이 인지하는 증상이 아닌 기술적 용어로 묘사해야 함</li>
                        <li>고장원인 : 하위 레벨의 고장형태와 요구사항, 잠재 noise 요소로부터 도출됨</li>
                        <p class="mg10"></p>
                        <h3>3. 양식 사용방법</h3>
                    </ul>`
                },
            ],
            bgm : "summary.mp3"
        },
        {
            title : 'Outro',
            type : 'outro',
            source : 'c11.mp4',
        },
    ]
}